module.exports = __webpack_public_path__ + "canada.svg?ed3cd4b507f8209412bc426332f23589";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/canada.svg
// module id = 127
// module chunks = 10